import { render } from "./TabLicenzaFatturazione.vue?vue&type=template&id=5b3e6888&scoped=true"
import script from "./TabLicenzaFatturazione.vue?vue&type=script&lang=js"
export * from "./TabLicenzaFatturazione.vue?vue&type=script&lang=js"

import "./TabLicenzaFatturazione.vue?vue&type=style&index=0&id=5b3e6888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3e6888"]])

export default __exports__